
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hP4wC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c22a390d74cb8774$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $c22a390d74cb8774$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': "\u6240\u6709\u7DB2\u7AD9",
    'navigation.global-shortcuts.apps.align': 'Align',
    'navigation.global-shortcuts.apps.analytics': "\u5206\u6790",
    'navigation.global-shortcuts.apps.assets': 'Assets',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': "\u516C\u53F8\u4E2D\u5FC3",
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': "\u76EE\u6A19",
    'navigation.global-shortcuts.apps.home': "\u9996\u9801",
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': "\u5C08\u6848",
    'navigation.global-shortcuts.apps.studio': "\u5DE5\u4F5C\u5BA4",
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': "\u5718\u968A",
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': "\u95DC\u9589",
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': "\u300C{name}\u300D\u7DB2\u7AD9",
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(\u76EE\u524D\u7121\u6CD5\u4F7F\u7528)",
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': "\u958B\u555F\u5916\u90E8\u9023\u7D50\u5716\u793A",
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': "(\u8F09\u5165\u4E2D)",
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': "(\u8F09\u5165\u4E2D)",
    'navigation.global-shortcuts.shortcut-action.open-menu-label': "\u958B\u555F\u9078\u55AE",
    'navigation.global-shortcuts.sites': "{productName} \u7DB2\u7AD9"
};

});


//# sourceMappingURL=zh_TW.8b5cdbb9.js.map
